//const axios = require('axios').default;
import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import { COMPANY_API_URL_LIST }from "../../routes/company/index.js";
import  store  from '../../../state/store';

async function getList(params, body) {
  let config= {
    headers:{
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "GET",
    url: setParamsToURL(COMPANY_API_URL_LIST.LIST_URL,params),
    post: body
  }
  return prepareRequest(config,request);
}

async function getBranchList(params, body) {
  let config= {
    headers:{
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "GET",
    url: setParamsToURL(COMPANY_API_URL_LIST.BRANCH_LIST_URL,params),
    post: body
  }
  return prepareRequest(config,request);
}
async function getCompanyBranchList(params, body) {
  let config= {
    headers:{
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "GET",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_BRANCH_LIST_URL,params),
    post: body
  }
  return prepareRequest(config,request);
}
async function addCompanyBranch(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "POST",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_BRANCH_ADD_URL,params),
    post: body
  }
  return prepareRequest(config, request);
}

async function updateCompanyBranch(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "PUT",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_BRANCH_UPDATE_URL,params),
    post: body
  }
  return prepareRequest(config, request);
}

async function deleteCompanyBranch(params, body,urlSegments) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "DELETE",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_BRANCH_DELETE_URL,params,urlSegments),
    post: body
  }
  return prepareRequest(config, request);
}

async function getCompanyWarehouseList(params, body) {
  let config= {
    headers:{
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "GET",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_WAREHOUSE_LIST_URL,params),
    post: body
  }
  return prepareRequest(config,request);
}
async function addCompanyWarehouse(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "POST",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_WAREHOUSE_ADD_URL,params),
    post: body
  }
  return prepareRequest(config, request);
}

async function updateCompanyWarehouse(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "PUT",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_WAREHOUSE_UPDATE_URL,params),
    post: body
  }
  return prepareRequest(config, request);
}

async function deleteCompanyWarehouse(params, body,urlSegments) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "DELETE",
    url: setParamsToURL(COMPANY_API_URL_LIST.COMPANY_WAREHOUSE_DELETE_URL,params,urlSegments),
    post: body
  }
  return prepareRequest(config, request);
}

async function getERPWarehouseList(params, body) {
  let config= {
    headers:{
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "GET",
    url: setParamsToURL(COMPANY_API_URL_LIST.ERP_WAREHOUSE_LIST_URL,params),
    post: body
  }
  return prepareRequest(config,request);
}


export { getList,
  getBranchList,
  getCompanyBranchList,
  addCompanyBranch,
  updateCompanyBranch,
  deleteCompanyBranch,
  getCompanyWarehouseList,
  addCompanyWarehouse,
  updateCompanyWarehouse,
  deleteCompanyWarehouse,
  getERPWarehouseList
};